<div *ngIf="!(league$ | async)?.entry">
    <div class="league--header category-esl-{{skillLevel}}">
      <div class="skill-level">
          <i class="esl-icon esl_label-esl-{{skillLevel}}"></i>
      </div>

      <div class="league--header__information">
        <h4 *ngIf="leagueInfo.name" class="title">
          {{ leagueInfo.name }}
        </h4>

        <div class="sub-title c-skeleton__text c-skeleton__text--inline c-skeleton__text--smaller"></div>
      </div>
    </div>
</div>

<div *ngIf="(league$ | async)?.entry as league">
    <div class="league--header category-esl-{{league.skillLevel}}">
      <div class="skill-level">
          <i class="esl-icon esl_label-esl-{{skillLevel}}"></i>
      </div>

      <div class="league--header__information">
        <h4 class="title">
          {{ league.name.full }}
        </h4>

        <div class="sub-title">
          <span *ngIf="leagueInfo.portalTitle && leagueInfo.portalPath" class="portal">
            {{ 'league-header:part-of' | translate }}

            <a href="{{leagueInfo.portalPath}}" [title]="leagueInfo.portalTitle">
              {{ leagueInfo.portalTitle }}
            </a>
            -
          </span>

          <a href="{{league.uri}}contestants/" class="players-count__link">
            {{ league.contestants.signedUp }}
            <span *ngIf="(isTeamLeague$ | async)">
              {{ 'league-interaction:n-teams' | translate:{count:league.contestants.signedUp} }}
            </span>

            <span *ngIf="!(isTeamLeague$ | async)">
              {{ 'league-interaction:n-players' | translate:{count:league.contestants.signedUp} }}
            </span>
          </a>

          <span
            *ngIf="(league.contestants.checkedIn || league.contestants.checkedIn >= 0) &&
            leagueStateLevel(league.state) >= leagueStateLevel('checkIn')"
            class="players-count"
            >
            ({{league.contestants.checkedIn}} {{'league-interaction:n-checked-in' | translate:{count:league.contestants.checkedIn} }})
          </span>
        </div>
      </div>
    </div>
</div>
